export default "__VITE_PUBLIC_ASSET__879f907f__"